import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";
import axios from "axios";

// Define an async thunk to fetch data from the API

export const fetchCommunityData = createAsyncThunk(
  "community/fetchCommunityData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityDataWithPagination = createAsyncThunk(
  "community/fetchCommunityData",
  async ({ page, page_size, searchQuery, sortBy, sortOrder }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/all-commuity-pagination", {
        params: {
          page: page,
          page_size: page_size,
          search: searchQuery,
          sort_by: sortBy,
          sort_order: sortOrder,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityDocName = createAsyncThunk(
  "community/fetchCommunityDocName",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/community/community_doc_name_list/"
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityByCommunityName = createAsyncThunk(
  "community/fetchCommunityDataByName",
  async ({ communityName, city }, { rejectWithValue }) => {
    try {
      // Build the query string dynamically
      const queryParams = new URLSearchParams();

      if (communityName) {
        queryParams.append("community_name", communityName);
      } else {
        console.error("communityName is empty or undefined");
      }

      if (city) {
        queryParams.append("city", city);
      }

      // Log the full query string to debug
      const queryString = queryParams.toString();

      // Make the API request with the query string
      const response = await axiosInstance.get(
        `/community/search/?${queryString}`
      );

      return response.data;
    } catch (error) {
      // Handle errors appropriately
      console.error("API call error:", error.response || error);
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

export const fetchCommunityByCommunityId = createAsyncThunk(
  "community/fetchCommunityDataById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/community/${id}/`);
      return response.data;
    } catch (error) {
      // Handle errors appropriately
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

export const createNewCommunity = createAsyncThunk(
  "community/createNewCommunityapi",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/community/", formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteCommunityData = createAsyncThunk(
  "community/deleteCommunityData",
  async (communityId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/community/${communityId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createNewCommunityGpt = createAsyncThunk(
  "community/createNewCommunity",
  async (communityData, { rejectWithValue }) => {
    try {
      // const token =
      //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTczMzczNDY5OCwianRpIjoiMjQyNTQ2NGQtMDliYS00NjNmLWI5YzUtOTlhMTEyNDZlZmE0IiwidHlwZSI6ImFjY2VzcyIsInN1YiI6ImN1c3RvbV9pZGVudGl0eSIsIm5iZiI6MTczMzczNDY5OCwiY3NyZiI6ImQ0OWZkYjZjLWI0ZTQtNGY0Ny05NTkyLWZmYTU2Njg4MjUwYyJ9.KvWMBSeOywS1FGDQJ5pPTMFIWNCtwCGnazNXzadAiuo";
      const response = await axios.post(
        "https://sdeiaiml.com:8004/community/community_check_or_create/",
        JSON.stringify(communityData),
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response
          ? {
            message: error.response.data.message,
            status: error.response.status,
          }
          : { message: error.message }
      );
    }
  }
);

export const updateCommunityApi = createAsyncThunk(
  "community/UpdateCommunityApi",
  async ({ formData, communityId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/community/${communityId}`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// export const vendorCheckOrCreate = createAsyncThunk(
//   "community/vendorCheckOrCreate",
//   async (communityCity, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         "https://sdeiaiml.com:8004/community/vendor_check_or_create/",
//         JSON.stringify(communityCity),
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response
//           ? {
//               message: error.response.data.message,
//               status: error.response.status,
//             }
//           : { message: error.message }
//       );
//     }
//   }
// );

// export const healthVendorCheckOrCreate = createAsyncThunk(
//   "community/vendorCheckOrCreate",
//   async (communityCity, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         "https://sdeiaiml.com:8004/community/health_vendor_check_or_create/",
//         JSON.stringify(communityCity),
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response
//           ? {
//               message: error.response.data.message,
//               status: error.response.status,
//             }
//           : { message: error.message }
//       );
//     }
//   }
// );

export const vendorCheckOrCreate = createAsyncThunk(
  "community/vendorCheckOrCreate",
  async (communityCity, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/vendor_check_or_create/",
        communityCity
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const healthVendorCheckOrCreate = createAsyncThunk(
  "community/healthVendorCheckOrCreate",
  async (communityCity, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/health_vendor_check_or_create/",
        communityCity
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const educationVendorCheckOrCreate = createAsyncThunk(
  "community/educationVendorCheckOrCreate",
  async (communityCity, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/community/education_vendor/",
        communityCity
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityDataByUserIdClaimStatus = createAsyncThunk(
  "community/fetchCommunityDataByUserIdClaimStatus",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/community/community_claim_status/${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const fetchApprovalCommunityData = createAsyncThunk(
  "community/fetchApprovalCommunityData",
  async ({ page, page_size, searchQuery }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "community/pending-approval-communities", {
        params: {
          page: page,
          page_size: page_size,
          search: searchQuery,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateApprovalCommunityData = createAsyncThunk(
  "community/fetchApprovalCommunityData",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        "community/pending-approval-communities", formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createNewGroup = createAsyncThunk(
  "community/createNewGroup",
  async ({ user_id, group_name, community_ids }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/community/create-group-directory", {
        user_id, group_name, community_ids
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchGroupData = createAsyncThunk(
  "community/fetchGroupData",
  async ({ group_name, page_size, page, page_number, group_page_size }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/create-group-directory", {
        params: {
          group_name: group_name,
          page_size: page_size,
          page: page,
          page_number: page_number,
          group_page_size: group_page_size,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateGroup = createAsyncThunk(
  "community/updateGroup",
  async ({ id, user_id, group_name, community_ids, is_default }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/community/update-group-directory/${id}`, {
        user_id, group_name, community_ids, is_default
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteGroupData = createAsyncThunk(
  "community/deleteGroupData",
  async (group_id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/community/create-group-directory`, {
        params: {
          group_id: group_id,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommunityHomeownerData = createAsyncThunk(
  "community/fetchCommunityHomeownerData",
  async ({ id, page, page_size, search }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/community/community-homeowners/${id}`, {
        params: {
          search: search,
          page: page,
          page_size: page_size,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchAllFloridaChapters = createAsyncThunk(
  "community/fetchAllFloridaChapters",
  async (chapter, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/all_florida_chapters", {
        params: {
          chapter: chapter,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const startCompliance = createAsyncThunk(
  "community/startCompliance",
  async ({ community_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "community/compliance-category",
        {
          community_id: community_id
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchComplianceCategories = createAsyncThunk(
  "community/fetchComplianceCategories",
  async (community_id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `community/compliance_category/${community_id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchComplianceCategoryDetails = createAsyncThunk(
  "community/fetchComplianceCategoryDetails",
  async ({ community_id, category_name }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `community/compliance_category_details/${community_id}`,
        {
          category_name: category_name
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const addNewComment = createAsyncThunk(
  "community/addNewComment",
  async ({ compliance_category, user_type, community_id, comment }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "community/compliance-comments/",
        {
          compliance_category: compliance_category,
          user_type: user_type,
          community: community_id,
          comment: comment
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCommentsByCommunityAndCategory = createAsyncThunk(
  "community/fetchCommentsByCommunityAndCategory",
  async ({ community_id, compliance_category }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "community/compliance-comments/", {
        params: {
          community: community_id,
          compliance_category: compliance_category,
        }
      }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateComment = createAsyncThunk(
  "community/updateComment",
  async ({ comment_id, comment, user_type }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        "community/compliance-comments/", {
        "comment_id": comment_id,
        "comment": comment,
        "user_type": user_type
      }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteComment = createAsyncThunk(
  "community/deleteComment",
  async (comment_id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`community/compliance-comments/${comment_id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateAssignedAssociationManager = createAsyncThunk(
  "community/updateComment",
  async ({ community_id, user_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        "community/change-association-manager/", {
        "community_id": community_id,
        "new_manager_id": user_id
      }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const fetchNewLawsAndAlerts = createAsyncThunk(
  "community/fetchNewLawsAndAlerts",
  async ({ year, page = 1, page_size = 12 } = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("page_size", String(page_size));
      if (year != null && year !== "") params.set("year", String(year));
      const response = await axiosInstance.get(
        `/community/law-changes/?${params.toString()}`
      );
      return response.data; // { message, data }
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ========================= Master Association Building Management APIs =========================

/**
 * Fetch communities available for grouping under a master association
 * @param {string} masterId - The master association UUID
 * @param {number} page - Page number (default: 1)
 * @param {number} page_size - Results per page (default: 20)
 * @param {string} search - Search query (optional)
 */
export const fetchAvailableCommunitiesForGrouping = createAsyncThunk(
  "community/fetchAvailableCommunitiesForGrouping",
  async ({ masterId, page = 1, page_size = 20, search = "" }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({
        master_id: masterId,
        page: page.toString(),
        page_size: page_size.toString(),
      });
      if (search && search.trim() !== "") {
        params.append("search", search.trim());
      }
      const response = await axiosInstance.get(
        `/community/superadmin/available-for-grouping/?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

/**
 * Fetch child communities (assigned buildings) for a specific master association
 * @param {string} masterId - The master association UUID
 * @param {number} page - Page number (default: 1)
 * @param {number} page_size - Results per page (default: 20)
 * @param {string} search - Search query (optional)
 */
export const fetchChildCommunitiesByMaster = createAsyncThunk(
  "community/fetchChildCommunitiesByMaster",
  async ({ masterId, page = 1, page_size = 20, search = "" }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({
        master_id: masterId,
        page: page.toString(),
        page_size: page_size.toString(),
      });
      if (search && search.trim() !== "") {
        params.append("search", search.trim());
      }
      const response = await axiosInstance.get(
        `/community/child-communities/?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

/**
 * Assign/unassign communities to/from a master association (bulk operation)
 * @param {string} masterId - The master association UUID
 * @param {Array<string>} communityIds - Array of community UUIDs to assign
 */
export const groupCommunitiesToMaster = createAsyncThunk(
  "community/groupCommunitiesToMaster",
  async ({ masterId, communityIds }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/community/superadmin/group-communities/${masterId}/`,
        { community_ids: communityIds }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchHealthCheckReport = createAsyncThunk(
  "community/fetchHealthCheckReport",
  async (community_id, { rejectWithValue }) => {
    try {
      // Fetch HTML content from backend (text/html response)
      const response = await axiosInstance.get(
        `community/health-check-report/${community_id}/html/`,
        {
          responseType: "text", // Important: fetch as text, not JSON
        }
      );
      return {
        html: response.data,
        status: response.status,
      };
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const generateHealthCheckReport = createAsyncThunk(
  "community/generateHealthCheckReport",
  async (community_id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "community/health-check/generate/",
        { community_id }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const sendHealthCheckEmail = createAsyncThunk(
  "community/sendHealthCheckEmail",
  async ({ community_id, emailData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `community/health-check-report/${community_id}/send-email/`,
        emailData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const saveHealthCheckBranding = createAsyncThunk(
  "community/saveHealthCheckBranding",
  async ({ community_id, logoFile, brand_color, remove_logo }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      
      // Add logo file if provided
      if (logoFile) {
        formData.append("logo", logoFile);
      }
      
      // Add brand color (defaults to #e55426 on backend if not provided)
      if (brand_color) {
        formData.append("brand_color", brand_color);
      }
      
      // Add remove_logo flag if true
      if (remove_logo) {
        formData.append("remove_logo", "true");
      }
      
      const response = await axiosInstance.post(
        `community/health-check-report/${community_id}/branding/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchHealthCheckBranding = createAsyncThunk(
  "community/fetchHealthCheckBranding",
  async (community_id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `community/health-check-report/${community_id}/branding/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

/*
 * Lease Management APIs
*/

export const fetchCommunityLeaseDocuments = createAsyncThunk(
  "community/fetchCommunityLeaseDocuments",
  async (
    { communityId, page = 1, page_size = 50, document_name = "" } = {},
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.get(
        `/community/${communityId}/leases/`,
        {
          params: {
            page,
            page_size,
            ...(document_name ? { document_name } : {}),
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createCommunityLeaseDocument = createAsyncThunk(
  "community/createCommunityLeaseDocument",
  async ({ communityId, payload }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/community/${communityId}/leases/`,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateCommunityLeaseDocument = createAsyncThunk(
  "community/updateCommunityLeaseDocument",
  async ({ communityId, leaseId, payload }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `/community/${communityId}/leases/${leaseId}/`,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteCommunityLeaseDocument = createAsyncThunk(
  "community/deleteCommunityLeaseDocument",
  async ({ communityId, leaseId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        `/community/${communityId}/leases/${leaseId}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
